import {Observable, of} from 'rxjs';
import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import {LoadAccount} from '../actions/accounts.actions';
import {catchError, filter, switchMapTo, take, tap} from 'rxjs/operators';

@Injectable()
export class AccountGuard implements CanActivate {

  constructor(private store: Store<fromRoot.State>) {
  }

  public canActivate(): Observable<boolean> {
    return this.checkAccount()
      .pipe(
        switchMapTo(of(true)),
        catchError(() => of(false))
      );
  }

  checkAccount(): Observable<boolean> {
    return this.store.pipe(
      select(fromRoot.selectAccountsLoaded),
      tap(isLoaded => {
        if (!isLoaded) {
          this.store.dispatch(LoadAccount());
        }
      }),
      filter(isLoaded => isLoaded),
      take(1)
    );
  }
}
